'use client'
import Script from "next/script"

const BreadcrumbsLdJson = ({ property }) => {

    let jsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `${process.env.NEXT_PUBLIC_SHARE_URL}`
        },{
          "@type": "ListItem",
          "position": 2,
          "name": "Property Categories",
          "item": `${process.env.NEXT_PUBLIC_SHARE_URL}/properties?category=${property.category.toLowerCase()}`
        },{
          "@type": "ListItem",
          "position": 3,
          "name": "Property in Pattaya",
          "item": `${process.env.NEXT_PUBLIC_SHARE_URL}/properties?location=${property.location}`
        },{
          "@type": "ListItem",
          "position": 4,
          "name": `Properties in ${property.districts?.[0]?.subdistrictName?.en}`,
          "item": `${process.env.NEXT_PUBLIC_SHARE_URL}/properties?district=${property?.districts?.[0]?._id}`
        },{
          "@type": "ListItem",
          "position": 5,
          "name": `${property.name}`,
          "item": `${process.env.NEXT_PUBLIC_SHARE_URL}/properties/${property.slug}`
        }]
      }
  
    return (
        <Script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
            key="breadcrumb-jsonld"
        />
    )
}

export default BreadcrumbsLdJson